import uuid from 'uuid/v4'
import ObjectUtil from '@leverege/object-util'
import ArrayUtil from '@leverege/array-util'
import { getAttributeCreatorFor, Interpolators } from '@leverege/api-attributes'
import { requestError, warn } from './NotifyActions'

const { LinearInterpolatorCreator, StepInterpolatorCreator } = Interpolators

const CREATE_SCENARIO = 'CREATE_SCENARIO'
const GET_SCENARIO = 'GET_SCENARIO'
const SET_SCENARIO = 'SET_SCENARIO'
const GET_SCENARIOS = 'GET_SCENARIOS'
const REMOVE_SCENARIO = 'REMOVE_SCENARIO'

const SAVING_SCENARIO = 'SAVING_SCENARIO'
const SAVED_SCENARIO = 'SAVED_SCENARIO'
const SAVE_ERROR_SCENARIO = 'SAVE_ERROR_SCENARIO'

// const SET_VALUE = "SET_VALUE"
// const REMOVE_VALUE = "REMOVE_VALUE"
// const CHANGE_TIME = 'CHANGE_TIME'

export function setScenario( scenario ) {
  
}

/**
 * Gets a list of scenarios with associated with the blueprint id,
 **/
export function getScenarios( projectId ) {
  return ( dispatch, getState, api ) => {

    const loadScenarios = ( projectId ) => {
      return api.getScenarios( projectId )
    }

    loadScenarios( projectId )
      .then( ( results ) => {
        dispatch( { type : GET_SCENARIOS, projectId, scenarios : results.items } )
      } )
      .catch( ( ex ) => {
        dispatch( requestError( 'Failed to get scenarios', ex ) )
      } )
  }
}

export function createScenario( options ) {

  return ( dispatch, getState, api ) => {
    let _blueprint
    const loadBlueprint = ( projectId, blueprintId ) => {
      return api.getBlueprint( projectId, blueprintId )
    }
    const saveScenario = ( blueprint ) => {
      _blueprint = blueprint
      const scenario = createScenarioFromBlueprint( blueprint )
      if ( scenario ) {
        return api.addScenario( blueprint.projectId, scenario ) 
      } 
      throw new Error( 'Unable to create scenario' )
      
    }
    const dispatchScenario = ( scenario ) => {
      dispatch( { type : CREATE_SCENARIO, scenario, blueprint : _blueprint } )
      dispatch( { type : GET_SCENARIO, scenario, blueprint : _blueprint } )
    }

    // To get the blueprint, we need either a projectId or a systemId + deviceId
    // Nee better access to this. Do Project for now
    if ( options.projectId && options.blueprintId ) {

      return loadBlueprint( options.projectId, options.blueprintId )
        .then( saveScenario )
        .then( dispatchScenario )
        .catch( ( ex ) => {
          dispatch( requestError( 'Failed to create scenario', ex ) )
        } )
    } 
    console.log( '---- NOT IMPLEMENTED ----' )
    
  }
}

export function duplicateScenario( projectId, id ) {

  return ( dispatch, getState, api ) => {

    let _scenario, _blueprint
    const loadScenario = ( projectId, scenarioId ) => {
      return api.getScenario( projectId, scenarioId )
    }
    const saveScenario = ( scenario ) => {
      if ( scenario ) {
        scenario.id = null
        scenario.name += ' Copy'
        return api.addScenario( projectId, scenario ) 
      } 
      throw new Error( 'Unable to create scenario' )
      
    }
    const dispatchScenario = ( scenario ) => {
      // dispatch( { type : CREATE_SCENARIO, scenario : scenario, blueprint : _blueprint } )
      dispatch( { type : CREATE_SCENARIO, scenario } )
      // router.history.push( `/project/${scenario.projectId}/scenario/${scenario.id}`)
    }

    loadScenario( projectId, id )
      .then( saveScenario )
      .then( dispatchScenario )
      .catch( ( ex ) => {
        dispatch( requestError( 'Failed to duplicate scenario', ex ) )
      } )
  }
}

/**
 * Gets a list of scenarios with associated with the blueprint id,
 **/
export function removeScenario( projectId, id ) {
  return ( dispatch, getState, api ) => {
    api.removeScenario( projectId, id )
      .then( ( e ) => {
        dispatch( { type : REMOVE_SCENARIO, id, projectId, projectId } )
      } )
      .catch( ( ex ) => {
        dispatch( requestError( 'Failed to remove scenario', ex ) )
      } )
  }
}
/**
 * Gets a list of scenarios with associated with the blueprint id,
 **/
export function getScenario( projectId, id ) {
  return ( dispatch, getState, api ) => {

    let _scenario, _blueprint
    const loadScenario = ( projectId, scenarioId ) => {
      return api.getScenario( projectId, scenarioId )
    }
    const loadBlueprint = ( scenario ) => {
      _scenario = scenario

      // make sure the updaters have timeline arrays
      if ( scenario.scenarioData.updaters ) {
        scenario.scenarioData.updaters.forEach( ( item ) => {
          if ( item.keyframes == null ) {
            item.keyframes = []
          }
        } )
      } else {
        scenario.scenarioData.updaters = []
      }

      return api.getBlueprint( projectId, scenario.blueprintId )
    }
    const dispatchScenario = ( blueprint ) => {
      _blueprint = blueprint
      if ( verify( _scenario, _blueprint ) ) {
        dispatch( warn( 'Note', 'The scenario was updated to match the blueprint' ) )
      }
      dispatch( { type : GET_SCENARIO, scenario : _scenario, blueprint } )
    }

    loadScenario( projectId, id )
      .then( loadBlueprint )
      .then( dispatchScenario )
      .catch( ( ex ) => {
        dispatch( requestError( 'Failed to read scenario', ex ) )
      } )
  }
}

export function setName( name ) {
  return ( dispatch, getState, api ) => {
    const { scenario } = getState()
    const nState = ObjectUtil.copy( scenario.scenario )
    nState.name = name;
    dispatch( { type : SET_SCENARIO, scenario : nState } )
    dispatch( saveScenario( nState ) )
  }
}

export function setBehavior( behavior ) {
  return ( dispatch, getState, api ) => {
    const { scenario } = getState()
    const nState = { ...scenario.scenario, scenarioData : { ...scenario.scenario.scenarioData } }
    nState.scenarioData.behavior = behavior
    dispatch( { type : SET_SCENARIO, scenario : nState } )
    dispatch( saveScenario( nState ) )
  }
}

export function setValue( path, value, time, attributeType ) {
  return ( dispatch, getState, api ) => {
    const { scenario } = getState()
    const nState = ObjectUtil.copy( scenario.scenario )

    let attr = ArrayUtil.find( nState.scenarioData.updaters, 'path', path )
    if ( attr == null ) {
      attr = { attributeType : attributeType || 'number', keyframes : [] }
      nState.scenarioData.updaters.push( attr )
    }

    const keyframes = attr.keyframes
    const index = indexAtOrBefore( keyframes, time )
    if ( index >= 0 && index < keyframes.length && keyframes[index].time == time ) {
      // replace the current node
      keyframes[index].value = value
    } else {
      // Add a new node
      const kf = { id : uuid(), time, value }
      if ( index >= 0 ) {
        kf.interpolator = ObjectUtil.copy( keyframes[index].interpolator )
      } else {
        // create a new one
        const creator = getAttributeCreatorFor( attributeType )
        const StepGeoPointInterpolatorCreator = Interpolators.getCreator( 'stepGeoPoint' )
        if ( LinearInterpolatorCreator.handles( creator ) ) {
          kf.interpolator = LinearInterpolatorCreator.create()
        } else if ( StepInterpolatorCreator.handles( creator ) ) {
          kf.interpolator = StepInterpolatorCreator.create()
        } else if ( StepGeoPointInterpolatorCreator.handles( creator ) ) {
          kf.interpolator = StepGeoPointInterpolatorCreator.create()
        }
      }
      keyframes.splice( index + 1, 0, kf )
    }
    dispatch( { type : SET_SCENARIO, scenario : nState } )
    dispatch( saveScenario( nState ) )
  }
}

export function setInterpolator( interpolator, path, keyframeId ) {
  return ( dispatch, getState, api ) => {
    const { scenario } = getState()
    const nState = ObjectUtil.copy( scenario.scenario )
    const timeline = ArrayUtil.find( nState.scenarioData.updaters, 'path', path )
    if ( timeline ) {
      const kf = ArrayUtil.find( timeline.keyframes, 'id', keyframeId )
      if ( kf ) {
        kf.interpolator = interpolator
        dispatch( { type : SET_SCENARIO, scenario : nState } )
        dispatch( saveScenario( nState ) )
      }
    }
  }
}

export function removeValue( path, keyframeId ) {
  return ( dispatch, getState, api ) => {
    const { scenario } = getState()
    const nState = ObjectUtil.copy( scenario.scenario )
    const timeline = ArrayUtil.find( nState.scenarioData.updaters, 'path', path )
    if ( timeline ) {
      if ( ArrayUtil.remove( timeline.keyframes, 'id', keyframeId ) >= 0 ) {
        dispatch( { type : SET_SCENARIO, scenario : nState } )
        dispatch( saveScenario( nState ) )
      }
    }
  }
}

// Change the time of one keyframe. 
export function changeTime( path, keyframeId, newTime ) {
  return ( dispatch, getState, api ) => {
    const { scenario } = getState()
    const nState = ObjectUtil.copy( scenario.scenario )

    const timeline = ArrayUtil.find( nState.scenarioData.updaters, 'path', path )
    if ( timeline ) {
      const kf = ArrayUtil.find( timeline.keyframes, 'id', keyframeId )
      if ( kf ) {
        kf.time = newTime
        timeline.keyframes.sort( sort )
        dispatch( { type : SET_SCENARIO, scenario : nState } )
        dispatch( saveScenario( nState ) )
      }
    }
  }
}
// Change the time of one keyframe. 
export function shiftLeft( path, keyframeId, newTime ) {
  return ( dispatch, getState, api ) => {
    const { scenario } = getState()
    const nState = ObjectUtil.copy( scenario.scenario )

    const timeline = ArrayUtil.find( nState.scenarioData.updaters, 'path', path )
    if ( timeline ) {
      const index = ArrayUtil.index( timeline.keyframes, 'id', keyframeId )
      if ( index >= 0 ) {
        const kf = timeline.keyframes[index]
        const dTime = newTime - kf.time 
        kf.time = newTime
        for ( let n = 0; n < index; n++ ) {
          timeline.keyframes[n].time += dTime
        }
        timeline.keyframes.sort( sort )
        dispatch( { type : SET_SCENARIO, scenario : nState } )
        dispatch( saveScenario( nState ) )
      }
    }
  }
}

// Change the time of one keyframe. 
export function shiftRight( path, keyframeId, newTime ) {
  return ( dispatch, getState, api ) => {
    const { scenario } = getState()
    const nState = ObjectUtil.copy( scenario.scenario )

    const timeline = ArrayUtil.find( nState.scenarioData.updaters, 'path', path )
    if ( timeline ) {
      const index = ArrayUtil.index( timeline.keyframes, 'id', keyframeId )
      if ( index >= 0 ) {
        const kf = timeline.keyframes[index]
        const dTime = newTime - kf.time 
        kf.time = newTime
        for ( let n = index + 1; n < timeline.keyframes.length; n++ ) {
          timeline.keyframes[n].time += dTime
        }
        timeline.keyframes.sort( sort )
        dispatch( { type : SET_SCENARIO, scenario : nState } )
        dispatch( saveScenario( nState ) )
      }
    }
  }
}
// Change the time of one keyframe. 
export function shiftAll( path, dTime ) {
  return ( dispatch, getState, api ) => {
    const { scenario } = getState()
    const nState = ObjectUtil.copy( scenario.scenario )

    const timeline = ArrayUtil.find( nState.scenarioData.updaters, 'path', path )
    if ( timeline ) {
      for ( let n = 0; n < timeline.keyframes.length; n++ ) {
        timeline.keyframes[n].time += dTime
      }
      timeline.keyframes.sort( sort )
      dispatch( { type : SET_SCENARIO, scenario : nState } )
      dispatch( saveScenario( nState ) )
    }
  }
}

const saveData = {}
const saveTimers = {}
function saveScenario( scenario ) {
  if ( scenario == null ) {
    return undefined
  }

  return ( dispatch, getState, api ) => {
    const id = scenario.id
    saveData[id] = scenario

    // only start timer after completion or failure of last one
    if ( saveTimers[id] == null ) {
      dispatch( { type : SAVING_SCENARIO, scenario } )

      saveTimers[id] = setTimeout( ( ) => {
        const data = saveData[id]
        delete saveData[id]

        api.putScenario( data ).then( ( res ) => {
          delete saveTimers[id]
          dispatch( { type : SAVED_SCENARIO, scenario : data } )
          // save next
          saveScenario( saveData[id] )
        } ).catch( ( ex ) => {
          delete saveTimers[id]
          dispatch( requestError( 'Failed to save scenario', ex ) )
          dispatch( { type : SAVE_ERROR_SCENARIO, scenario : data, exception : ex } )
          // try again, with either newer data or current
          saveScenario( saveData[id] || data )
        } )
      }, 5000 )
    }
  }
}

function createScenarioFromBlueprint( blueprint ) {

  if ( blueprint ) {
    const updaters = []

    blueprint.attributes.forEach( ( attr, index ) => {
      updaters.push( createUpdaterTimeline( attr ) )
    } )

    return { id : null,
             name : `${blueprint.name} Scenario`, 
             projectId : blueprint.projectId,
             blueprintId : blueprint.id, 
             tags : [], 
             scenarioData : { 
               behavior : { type : 'pass' },
               updaters, 
               thresholds : [] 
             }
    }
  } 
  return null
}

function createUpdaterTimeline( attr ) {
  return { 
    path : attr.path,
    attributeType : attr.type, 
    attributeId : attr.id,
    keyframes : [ ]
  }
}

function sort( a, b ) {
  return a.time < b.time ? -1 : a.time > b.time ? 1 : 0
}

function indexAtOrBefore( list, time ) {
  for ( let n = 0; n < list.length; n++ ) {
    if ( list[n].time > time ) {
      return n - 1
    }
  }
  return list.length - 1
}

// verifies and converts scenario to be useful to the blueprint
function verify( scenario, blueprint ) {

  const updaters = scenario.scenarioData.updaters
  const left = [].concat( updaters )
  const verified = []
  let changed = false

  blueprint.attributes.forEach( ( attr, index ) => {
    const type = attr.type
    const pIndex = ArrayUtil.index( left, 'path', attr.path )
    const iIndex = ArrayUtil.index( left, 'attributeId', attr.id )

    if ( pIndex == iIndex ) {
      if ( pIndex < 0 ) {
        // not found - add it. the attribute never existed
        verified.push( createUpdaterTimeline( attr ) )
        changed = true
      } else if ( type == left[pIndex].attributeType ) {
        // perfect match, path, attributeType and attributeId match
        verified.push( left[pIndex] )
        left.splice( pIndex, 1 )
      } else {
        // Types are invalid. make new one for this attribute
        verified.push( createUpdaterTimeline( attr ) )
        left.splice( pIndex, 1 ) // nothing else can use this
        changed = true 
      }
    } else if ( pIndex < 0 ) {
      // found it by attribute id. assume correct if types match
      if ( type == left[iIndex].attributeType ) {
        left[iIndex].path = attr.path
        verified.push( left[iIndex] )
        left.splice( iIndex, 1 )
      } else {
        // no matching type. create new one, null index
        verified.push( createUpdaterTimeline( attr ) )
        left[iIndex].attributeId = null
        changed = true
      }
    } else if ( type === left[pIndex].attributeType ) {
      left[pIndex].attributeId = attr.id
      verified.push( left[pIndex] )
      left.splice( pIndex, 1 )
    } else {
      // no matching type, create new one and null path
      verified.push( createUpdaterTimeline( attr ) )
      left[pIndex].path = null
      changed = true
    }
  } )
  if ( left.length > 0 || verified.length != scenario.scenarioData.updaters.length ) {
    changed = true
  }
  scenario.scenarioData.updaters = verified
  return changed
}

module.exports = {
  GET_SCENARIO,
  CREATE_SCENARIO,
  GET_SCENARIOS,
  REMOVE_SCENARIO,
  SET_SCENARIO,
  SAVING_SCENARIO,
  SAVED_SCENARIO,
  SAVE_ERROR_SCENARIO,
  // SET_VALUE, REMOVE_VALUE, CHANGE_TIME,
  
  createScenario,
  duplicateScenario,
  getScenario,
  getScenarios,
  removeScenario,
  setValue,
  removeValue,
  changeTime,
  shiftLeft,
  shiftRight,
  shiftAll,
  setName,
  setInterpolator,
  setBehavior,
}
